import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BlogProvider } from './context/BlogContext';
import { StatutoryWarningProvider } from './context/StatutoryWarningContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BlogProvider>
        <BrowserRouter>
          <StatutoryWarningProvider>
            <App />
          </StatutoryWarningProvider>
        </BrowserRouter>
      </BlogProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
